<style lang="scss"></style>

<!-- eslint-disable -->
<template>
  <section>
    <b-card>
      <b-card-title class="d-flex align-items-center">
        Additional Participants

        <div class="ui-spacer"></div>
        <b-btn @click="addMode = !addMode" size="sm" v-if="showAddBtn"
               variant="success" class="mr-1"><span class="fa fa-plus"></span> Add</b-btn>
      </b-card-title>

      <section v-if="additionalVisitors.length">
        <b-table
          class="data-table"
          hover
          :items="additionalVisitors"
          :fields="headers"
          :per-page="perPage"
          :responsive="true"
          :current-page="currentPage"
        >
          <template #cell(birthDateAndAge)="data">
            <span class="d-inline-block" style="width: 115px">{{data.item.birthDateAndAge}}</span>
            <span v-if="data.item.under18 && !data.item.safeguarded_at_prison" class="badge badge-danger badge-pill">UNDER 18</span>
            <span v-else-if="data.item.under18  && data.item.safeguarded_at_prison" class="badge badge-success badge-pill">UNDER 18</span>
          </template>

          <template #cell(actions)="data">
            <b-dropdown class="m-0" variant="link" right toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item-button class="full-nested-btn" @click="showModal('modal-view-participant', true, data.item)">
                View
              </b-dropdown-item-button>
              <b-dropdown-item-button v-if="showRemoveBtn" class="full-nested-btn"
                                      @click="showModal('modal-remove', true, data.item)">
                Remove from call
              </b-dropdown-item-button>
            </b-dropdown>
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1" v-if="additionalVisitors.length > 0">
            <b-pagination :total-rows="additionalVisitors.length" :per-page="perPage" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="additionalVisitors.length === 0" class="col-6 ml-2 my-1">No visitors to show</p>
        </b-row>
      </section>

      <p v-else>Visitor has no Additional Participants.</p>

      <section v-if="addMode" class="mt-2">
        <add-additional-visitors @view="showModal('modal-view-participant', true, $event)"></add-additional-visitors>
      </section>

      <b-modal id="modal-remove" hide-footer>
        <warning-modal key="remove-warning" title="Are you sure you want to remove participant"
                       :subtitle="activeParticipant.firstname + ' ' + activeParticipant.lastname + '?'"
                       @close="closeAllModalAndRefresh()" @ok="removeFromCall(activeParticipant)" v-if="activeParticipant" :call="activeParticipant"></warning-modal>
      </b-modal>

      <b-modal id="modal-view-participant" size="lg" hide-footer>
        <additional-visitor-details v-if="activeParticipant" @close="closeAllModalAndRefresh()"
                                    :additional_visitor_id="activeParticipant.additional_visitor_id"></additional-visitor-details>
      </b-modal>
    </b-card>
  </section>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import AdditionalVisitorsService from '@/services/AdditionalVisitorsService';
import WarningModal from '@/components/modals/WarningModal';
import AddAdditionalVisitors from '@/components/calls/AddAdditionalVisitors';
import AdditionalVisitorDetails from '@/components/additionalVisitors/details/AdditionalVisitorDetails';

export default {
  components: {
    WarningModal,
    AddAdditionalVisitors,
    AdditionalVisitorDetails,
  },
  props: {
    showAddBtn: {
      type: Boolean,
      default: true,
    },
    showRemoveBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      perPage: 5,
      currentPage: 1,
      headers: [
        { key: 'fullName', label: 'Name'},
        { key: 'birthDateAndAge', label: 'Date of Birth'},
        { key: 'actions', label: ''},
      ],
      activeParticipant: null,
      loading: false,
      addMode: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
      additionalVisitors: state => state.callDetails.additionalVisitors,
    }),
  },
  mounted() {

  },
  methods: {
    showModal(name, value, person = null) {
      this.addMode = false;
      this.activeParticipant = person;
      if (value) {
        this.$bvModal.show(name);
      } else {
        this.$bvModal.hide(name);
      }
    },
    closeAllModalAndRefresh() {
      this.$bvModal.hide('modal-remove');
      this.$bvModal.hide('modal-view-participant');
      this.$store.dispatch('callDetails/getCall', this.call._id);
    },
    removeFromCall(participant) {
      this.loading = true;
      AdditionalVisitorsService.removeAdditionalVisitorFromVisit(this.call._id, participant.additional_visitor_id).then(() => {
        this.$toast.success(`${participant.firstname} removed from call`, {
          toastClassName: ['toast-std', 'success-toast'],
        });
      }).catch(err => {
        this.$toast.error('Could not remove participant from call, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
        this.closeAllModalAndRefresh();
      })
    },
  },
};
</script>
